<div class="not-found">
  <div class="container">
    <h1>404</h1>
    <h2>Oops! Page not found</h2>
    <p>The page you are looking for does not exist or you don't have the rights to access to it.</p>
  </div>
</div>
